import 'antd/dist/antd.less';
import React, { useEffect, useState } from 'react';
import './App.less';
import { Routes, Route, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import Privacy from '../src/screen/auth/view/privacy';
import Onboarding from '../src/screen/auth/view/onboarding';
import EditProfile from './screen/auth/view/editProfile';
// import InventoryView from './screen/distributor/view/inventory/inventoryView';
// import InventoryViewCompany from './screen/distributor/view/inventory/inventoryViewCompany';
// import EditInvoice from './screen/distributor/view/invoices/editInvoice';
// import InvoiceDetails from './screen/distributor/view/invoices/invoiceDetails';
// import EditInvoiceDetails from './screen/distributor/view/invoices/editInvoiceDetails';
// import SearchBuyer from './screen/distributor/view/sell_to_buyer/searchBuyer';
// import AddBuyer from './screen/distributor/view/sell_to_buyer/addBuyer';
// import OnBoardingMason from './screen/distributor/view/sell_to_buyer/onboardingBuyer';
// import BuyerAddProduct from './screen/distributor/view/sell_to_buyer/BuyerAddProduct';
// import BuyerSellDetails from './screen/distributor/view/sell_to_buyer/BuyerSellDetails';
// import UserInvoices from './screen/distributor/view/invoices/userInvoice';
// import SingleInvoice from './screen/distributor/view/invoices/singleInvoice';
// import Transaction from './screen/distributor/view/transactions/transaction';
// import ViewOrders from './screen/distributor/view/orders/viewOrders';
// import OrderNow from './screen/distributor/view/orders/ordernow';
// import AddProducts from './screen/distributor/view/orders/addproducts';
// import Checkout from './screen/distributor/view/orders/checkout';
// import VerifyBuyer from './screen/distributor/view/sell_to_buyer/verifyBuyer';
// import SaleDetails from './screen/distributor/view/sale_agg/saleDetails';
// import SaleDetailsCompany from './screen/distributor/view/sale_agg/saleDetailsCompany';
// import OnboardingCompanyUser from './screen/auth/view/profile/onboardingCompanyUser';
// import VerifyRetailer from './screen/distributor/view/sell_to_buyer/verifyRetailer';
// import SellInvoices from './screen/distributor/view/invoices/sellInvoices';
// import Benefits from './screen/distributor/view/SchemeBenefit/Benefits';
// import PersonalProfiler from './screen/distributor/view/profiler/PersonalProfiler';
// import AllPersonalProfilers from './screen/distributor/view/profiler/AllPersonalProfilers';
// import AllBusinessProfilers from './screen/distributor/view/profiler/AllBusinessProfiler';
// import DownloadCertificate from './screen/distributor/view/SchemeBenefit/DownloadCertificate';
// import ShilpkarEdit from './screen/distributor/view/sell_to_buyer/shipkarEdit';
// import OrderBooking from './screen/distributor/view/orderBooking/orderBooking';
// import AddUserForOrder from './screen/distributor/view/orders/addUserForOrder';
// import LedgerBalance from './screen/distributor/view/ledgerbalance/LedgerBalance';
// import OrderDetails from './screen/distributor/view/orders/orderDetails';
// import ShipToPartyList from './screen/distributor/view/orders/ShipToPartyList';
// import PurchaseOrder from './screen/distributor/view/orderBooking/orderPurchase';
// import RetailerAssociateOrder from './screen/distributor/view/retailerAssociateOrder/retailerAssociateOrder';
// import AddProductForRetailerAndAssociate from './screen/distributor/view/retailerAssociateOrder/addProductForRetailerAndAssociate';
// import AllSecondaryOrders from './screen/distributor/view/retailerAssociateOrder/allsecondaryOrders';
// import ViewOrdersDispatchCompleted from './screen/distributor/view/orders/viewOrderDispatchCompleted';
// import SecondaryOrderDetails from './screen/distributor/view/retailerAssociateOrder/secondaryOrderDetails';
// import DownloadInsurance from './screen/distributor/view/downloadInsurance/downloadInsurance';
// import AllBenefits from './screen/distributor/view/SchemeBenefit/AllBenefits';
// import PLPView from './v2/PLP/view/PLPView';
// import PDPView from './v2/PDP/View/PDPView';
// import OrderBookingViewController from './v2/OrderBookingViewController/OrderBookingViewController';
// import FmcgBuyerSellDetails from './screen/distributor/view/sell_to_buyer/fmcgBuyerSellDetails';
// import Reports from './v2/Reports/View/Reports';
// import VcpPerformanceReport from './v2/Reports/View/VcpPerformanceReport';
// import PoPerformanceReport from './v2/Reports/View/PoPerfromanceReport';
// import VcpDetailedPerformance from './v2/Reports/View/VcpDetailedPerformance';
// import { onMessageListener } from './firebase';
// import Toast from './components/Toast/Toast';
// import AllGifts from './v2/Benefits/Rewards/AllGifts';

import i18n from '../src/translations/i18n';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store from '../src/utils/store';
import ResetPassword from './screen/auth/view/resetPassword';
import ChangePhoneNumber from './screen/auth/view/changePhoneNumbe';
import SingleGift from './v2/Benefits/Rewards/SingleGift';

import Notifications from './screen/distributor/view/notifications/notifications';
import ProductPricing from './screen/distributor/view/productPricing/productPricing';
import Payment from './screen/distributor/view/Payment/Payment';
import UserReports from './screen/distributor/view/UserReports/userReports';
import GoldenAgePlanListing from './screen/distributor/view/SchemeBenefit/goldenAgePlanListing';
import PaymentHistory from './screen/distributor/view/ledgerbalance/PaynentHistory';
import CartViewController from './v2/Inventory/CartViewController';
import Home from './v2/Home/Home';
import FmcgInventory from './v2/FMCG/FmcgInventory';
import OrderComplete from './v2/FMCG/OrderComplete';
import LoginV2 from './v2/Onboarding/View/LoginV2';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import VerifyV2 from './v2/Onboarding/View/VerifyV2';
import ForgotPasswordV2 from './v2/Onboarding/View/ForgotPasswordV2';
import RegisterV2 from './v2/Onboarding/View/RegisterV2';
import CreatePassword from './v2/Onboarding/View/CreatePassword';
import UserOnboarding from './v2/Onboarding/View/UserOnboarding';
import IndustrySelect from './v2/Onboarding/View/FirmOnboarding/industrySelect';
import SubIndustrySelect from './v2/Onboarding/View/FirmOnboarding/subIndustrySelect';
import CompanyAndRoleSelect from './v2/Onboarding/View/FirmOnboarding/companyAndRoleSelect';
import FetchFirmDetail from './v2/Onboarding/View/FirmOnboarding/fetchFirmDetail';
import FirmOnboarding from './v2/Onboarding/View/FirmOnboarding/firmOnboarding';
import FirmOnboardingSummary from './v2/Onboarding/View/FirmOnboarding/firmOnboardingSummary';
import POSelectIndustry from './v2/BCMOrder/POSelectIndustry';
import UserDetail from './v2/MyAccount/UserDetail';
import FirmDetail from './v2/MyAccount/FirmDetail';
import EmployeeDetails from './v2/MyAccount/EmployeeDetail';
import AddNewEmployee from './v2/MyAccount/AddNewEmployee';
import POBooking from './v2/BCMOrder/POBooking';
import PurchaseOrderList from './v2/BCMOrder/PurchaseOrdersList';
import PODetails from './v2/BCMOrder/PODetails';
import ChangeCredentials from './v2/MyAccount/ChangeCredential';
import { FAQ } from './v2/MyAccount/faq';
import ContactUsAndPolicies from './v2/MyAccount/ContactUsAndPolicies';
import SelectShipToParty from './v2/BCMOrder/SelectShipToParty';
import AddProduct from './v2/BCMOrder/AddProducts';
import ShipToPartyDetails from './v2/BCMOrder/ShipToPartyDetails';
import SelectedShipToPartyList from './v2/BCMOrder/SelectedShipToPartyList';
import DispatchStatusList from './v2/BCMOrder/DispatchStatusList';
import DispatchStatusDetails from './v2/BCMOrder/DispatchStatusDetails';
import ProductList from './v2/FMCG/ProductList';
import ProductDescription from './v2/FMCG/ProductDescription';
import OnboardBuyer from './v2/OnboardBuyer/OnboardBuyer';
import SecondaryOrderList from './v2/BCMOrder/SecondaryOrderList';
import AttachedOrders from './v2/BCMOrder/AttachedOrders';
import HumbeeBenefits from './v2/Benefits/HumbeeBenefits/HumbeeBenefits';
import Inventory from './v2/Inventory/Inventory';
import MyBenefitsOld from './v2/Benefits/MyBenefits/MyBenefits';
import BeneficiaryDetails from './v2/Benefits/MyBenefits/BeneficiaryDetails';
import AddNewBeneficiary from './v2/Benefits/MyBenefits/AddNewBeneficiary';
import AvailableBenefits from './v2/Benefits/MyBenefits/AvailableBenefits';
import BeneficiarySummary from './v2/Benefits/MyBenefits/BeneficiarySummary';
import InvoicesList from './v2/BCMOrder/InvoicesList';
import InvoiceDetailed from './v2/BCMOrder/InvoiceDetailed';
import KnowYouBetter from './v2/Profilers/View/KnowYouBetter';
import BusinessProfiler from './v2/Profilers/View/BusinessProfiler';
import AuthWrapper from './Layouts/AuthWrapper';
import NotFound from './v2/error/NotFound';
import { ToastContainer } from 'react-toastify';
import MyPerformance from './v2/Performance/View/MyPerformance';
import VcpPerformanceDirectory from './v2/Performance/View/VcpPerformanceDirectory';
import VcpSalesDashBoard from './v2/Performance/View/VcpSalesDashBoard';
import PoPerformanceDetails from './v2/Performance/View/PoPerformanceDetails';
import GlobalWrapper from './Layouts/GlobalWrapper';
import MyBusinessSideBar from './v2/SideBar/myBusinessSideBar';
import MyAccountSideBar from './v2/SideBar/myAccountSidebar';
import MyPerformanceSideBar from './v2/SideBar/MyPerformanceSideBar';
import MyBenefitSideBar from './v2/SideBar/myBenefitsSidebar';
import HomeWrapper from './Layouts/HomeWrapper';
import MyRewards from './v2/Benefits/Rewards/MyRewards';
import RewardDetails from './v2/Benefits/Rewards/RewardDetails';
import RewardHistory from './v2/Benefits/Rewards/RewardHistory';
import MyNetwork from './v2/Benefits/Rewards/MyNetworkRewards';

import CompanyWiseInventory from './v2/Inventory/CompanyWiseInventory';
import Overview from './v2/Benefits/BenefitsRevamp/Overview';
import MyBenefits from './v2/Benefits/BenefitsRevamp/MyBenefits';
import SingleBenefit from './v2/Benefits/BenefitsRevamp/SingleBenefit';
import GapCalculator from './v2/Benefits/BenefitsRevamp/GapCalculator';
import PWASubMenu from './v2/GlobalSidebar/PWASubMenu';
import MainMenuScreen from './v2/GlobalSidebar/PWAMainSidebar';
import { decodeToken } from './utils/settings';
import TempTnc from './v2/Benefits/BenefitsRevamp/TempTnc';
import ScrollToTop from './v2/ScrollTop';

import PWAFAQ from './v2/FAQ/PWAFaq';
function App() {
  const language = localStorage.getItem('language');
  if (language) {
    i18n.changeLanguage(language);
  }
  useEffect(() => {
    if (process.env.REACT_APP_PROD === 'true') {
      const handleContextMenu = (event) => {
        event.preventDefault();
      };

      document.addEventListener('contextmenu', handleContextMenu);

      return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
      };
    }
  }, []);
  useEffect(() => {
    if (process.env.REACT_APP_PROD === 'true') {
      const handleCopy = (event) => {
        event.preventDefault();
      };

      const handleCut = (event) => {
        event.preventDefault();
      };

      const handlePaste = (event) => {
        event.preventDefault();
      };

      document.addEventListener('copy', handleCopy);
      document.addEventListener('cut', handleCut);
      document.addEventListener('paste', handlePaste);

      return () => {
        document.removeEventListener('copy', handleCopy);
        document.removeEventListener('cut', handleCut);
        document.removeEventListener('paste', handlePaste);
      };
    }
  }, []);

  // PWA Setup
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pwaJwt = searchParams.get('token');
  if (pwaJwt) {
    localStorage.setItem('token', pwaJwt);
  }

  const [tokenData, setTokenData] = useState({});

  const getTokenData = async () => {
    const decoded = await decodeToken();
    setTokenData(decoded);
  };

  useEffect(() => {
    getTokenData();
  }, []);

  let isPwa = false;
  if (tokenData && tokenData?.pwa_module) {
    isPwa = true;
  }

  const routes = {
    basicRoutes: [
      { path: '/resetpassword', element: <ResetPassword /> },
      { path: '/changeNumber', element: <ChangePhoneNumber /> },
      { path: '/onboarding', element: <Onboarding /> },
      { path: '/editonboarding', element: <EditProfile /> },
      { path: '/onboard-buyer', element: <OnboardBuyer /> },
      { path: '/humbee-benefits', element: <HumbeeBenefits /> },
    ],
    HomeRoute: [{ path: '/', element: <Home /> }],
    authRoutes: [
      { path: '/privacy', element: <Privacy /> },
      { path: '/login', element: <LoginV2 /> },
      { path: '/LoginViaOtp', element: <VerifyV2 /> },
      { path: '/VerifyUserForForgotPassword', element: <VerifyV2 /> },
      { path: '/VerifyUserForRegister', element: <VerifyV2 /> },
      { path: '/ForgotPassword', element: <ForgotPasswordV2 /> },
      { path: '/Register', element: <RegisterV2 /> },
      { path: '/CreatePassword', element: <CreatePassword /> },
      { path: '/UserOnboarding', element: <UserOnboarding /> },
      { path: '/IndustrySelect', element: <IndustrySelect /> },
      { path: '/SubIndustrySelect', element: <SubIndustrySelect /> },
      { path: '/CompanyAndRoleSelect', element: <CompanyAndRoleSelect /> },
      { path: '/FetchFirmDetail', element: <FetchFirmDetail /> },
      { path: '/FirmOnboarding', element: <FirmOnboarding /> },
      { path: '/FirmOnboardingSummary', element: <FirmOnboardingSummary /> },
      { path: '*', element: <NotFound /> },
    ],
    myBussinessRoutes: [
      { path: '/distributor/payment', element: <Payment /> },
      {
        path: '/order-booking/po-select-industry',
        element: <POSelectIndustry />,
      },
      { path: '/order-booking/po-booking', element: <POBooking /> },
      { path: '/order-booking/po-details', element: <PODetails /> },
      { path: '/order-booking/attached-orders', element: <AttachedOrders /> },

      {
        path: '/order-booking/select-ship-to-party/secondary-order',
        element: <SelectShipToParty />,
      },
      {
        path: '/order-booking/selected-ship-to-party-list',
        element: <SelectedShipToPartyList />,
      },

      {
        path: '/order-booking/dispatch-status-list',
        element: <DispatchStatusList />,
      },
      { path: '/order-booking/completed-invoices', element: <InvoicesList /> },
      {
        path: '/order-booking/invoice-details/:id',
        element: <InvoiceDetailed />,
      },
      {
        path: '/order-booking/dispatch-status-details',
        element: <DispatchStatusDetails />,
      },
      { path: '/order-booking/add-products', element: <AddProduct /> },
      { path: '/order-booking/po-list', element: <PurchaseOrderList /> },
      {
        path: '/order-booking/secondar-orders-list',
        element: <SecondaryOrderList />,
      },
      { path: '/order-booking/product-list', element: <ProductList /> },
      {
        path: '/order-booking/product-description',
        element: <ProductDescription />,
      },
      { path: '/distributor/productPricing', element: <ProductPricing /> },
      { path: '/distributor/paymentHistory', element: <PaymentHistory /> },
      { path: '/distributor/userReports', element: <UserReports /> },
    ],
    inventoryRoutes: [
      {
        path: '/order-booking/ship-to-party-details',
        element: <ShipToPartyDetails />,
        title: 'Ship To Party Details',
      },
      {
        path: '/order-booking/select-ship-to-party',
        element: <SelectShipToParty />,
        title: 'Select Ship To Party',
      },
      {
        path: '/distributor/inventory',
        element: <Inventory />,
        title: 'Inventory & Sell To Buyer',
      },
      {
        path: '/fmcg/buyer-cart',
        element: <CartViewController />,
        title: 'Cart',
      },
      { path: '/fmcg/order-completed', element: <OrderComplete /> },
      {
        path: '/fmcg/inventory',
        element: <FmcgInventory />,
        title: 'Inventory',
      },
      {
        path: '/distributor/company-wise-inventory',
        element: <CompanyWiseInventory />,
        title: 'Company Wise Inventory ',
      },
    ],
    distributorRoutes: [
      { path: '/distributor/notifications', element: <Notifications /> },
      {
        path: '/distributor/GoldenAgePlanListing',
        element: <GoldenAgePlanListing />,
      },
    ],
    myPerformanceRoutes: [
      { path: '/my-performance/Performance', element: <MyPerformance />, title: 'My Performance' },
      {
        path: 'my-performance/network-performance',
        element: <VcpPerformanceDirectory />,
        title : 'My Network Performance',
      },
      {
        path: '/my-performance/VCPSalesDashBoard',
        element: <VcpSalesDashBoard />,
        title: 'My Network Performance'
      },
      {
        path: '/my-performance/PoPerformanceDetails',
        element: <PoPerformanceDetails />,
        title: 'My Performance'
      },
    ],
    myBenefitsRoutes: [
      {
        path: '/benefits/network-rewards',
        element: <MyNetwork />,
        title: 'Network Rewards',
      },
      {
        path: '/benefits/rewards-history',
        element: <RewardHistory />,
        title: 'Reward History',
      },
      {
        path: '/benefits/rewards',
        element: <MyRewards />,
        title: 'My Rewards',
      },
      {
        path: '/benefits/reward-detail',
        element: <RewardDetails />,
        title: 'Reward Details',
      },
      {
        path: '/benefits/mybenefits',
        element: <MyBenefitsOld />,
        title: 'My Benefits',
      },
      {
        path: '/benefits/single-benefit',
        element: <SingleBenefit />,
        title: 'Benefit Detail',
      },
      { path: '/benefits/overview', element: <Overview />, title: 'Overview' },
      //Remove temptnc
      {
        path: '/benefits/Tnc',
        element: <TempTnc />,
        title: 'Terms & Conditions',
      },
      {
        path: '/benefits/gap-calculator',
        element: <GapCalculator />,
        title: 'Gap Calculator',
      },
      {
        path: '/my-benefits/beneficiary-details',
        element: <BeneficiaryDetails />,
        title: 'Edit Details',
      },
      {
        path: '/my-benefits/add-beneficiary',
        element: <AddNewBeneficiary />,
        title: 'Add New Beneficiary',
      },
      {
        path: '/my-benefits/benefits-available',
        element: <AvailableBenefits />,
        title: 'Available Benefits',
      },
      {
        path: '/my-benefits/benefits-summary',
        element: <BeneficiarySummary />,
        title: 'Beneficiary Details',
      },
      {
        path: '/distributor/giftsdetails',
        element: <SingleGift />,
        title: 'Gift Details',
      },
    ],
    myAccountsRoutes: [
      { path: '/my-account/user-details', element: <UserDetail /> },
      { path: '/my-account/firm-details', element: <FirmDetail /> },
      { path: '/my-account/employee-details', element: <EmployeeDetails /> },
      { path: '/my-account/firm-details/add', element: <AddNewEmployee /> },
      {
        path: '/my-account/change-credentials',
        element: <ChangeCredentials />,
      },
      { path: '/my-account/faq', element: <FAQ /> },
      {
        path: '/my-account/contact-us-and-policies',
        element: <ContactUsAndPolicies />,
      },
      { path: '/my-account/know-you-better', element: <KnowYouBetter /> },
      { path: '/my-account/business-profiler', element: <BusinessProfiler /> },
    ],
    PWARoute: [{ 
      path: '/pwa-main-menu', element: <MainMenuScreen />
      
    }],
    PWAAddons: [
      {path: '/pwa-faq', element: <PWAFAQ />, title: 'FAQ',},
      {path: '/pwa-mybenefit', element: <MyBenefits />, title: 'My Benefits'}
  ],
  };
  return (
    <div className='App'>
      <ThemeProvider theme={theme}>
        <Provider store={store.store}>
          <PersistGate
            loading={null}
            persistor={store.persistor}
          >
            <ToastContainer />
            <ScrollToTop />
            <Routes>
              {routes.HomeRoute.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <HomeWrapper SidebarComponent={null}>
                      {route.element}
                    </HomeWrapper>
                  }
                />
              ))}
              {routes.basicRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <GlobalWrapper
                      SidebarComponent={null}
                      sidebarTitle={route?.title}
                    >
                      {route.element}
                    </GlobalWrapper>
                  }
                />
              ))}

              {routes.myBussinessRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <GlobalWrapper
                      SidebarComponent={ MyBusinessSideBar }
                      sidebarTitle={route?.title ? route?.title : 'My Business' }
                    >
                      {route.element}
                    </GlobalWrapper>
                  }
                />
              ))}
              {routes.inventoryRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <GlobalWrapper
                      SidebarComponent={isPwa ? PWASubMenu : MyBusinessSideBar}
                      sidebarTitle={route?.title}
                      isPwa={isPwa}
                    >
                      {route.element}
                    </GlobalWrapper>
                  }
                />
              ))}
              {routes.distributorRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <GlobalWrapper SidebarComponent={null}>
                      {route.element}
                    </GlobalWrapper>
                  }
                />
              ))}
              {routes.myPerformanceRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <GlobalWrapper
                      SidebarComponent={isPwa ? PWASubMenu : MyPerformanceSideBar}
                      sidebarTitle={route?.title}
                      isPwa={isPwa}
                    >
                      {route.element}
                    </GlobalWrapper>
                  }
                />
              ))}
              {routes.myBenefitsRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <GlobalWrapper
                      SidebarComponent={isPwa ? PWASubMenu : MyBenefitSideBar}
                      sidebarTitle={route?.title}
                      isPwa={isPwa}
                    >
                      {route.element}
                    </GlobalWrapper>
                  }
                />
              ))}
              {routes.myAccountsRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <GlobalWrapper
                      SidebarComponent={MyAccountSideBar}
                      sidebarTitle={'Manage Your Account'}
                    >
                      {route.element}
                    </GlobalWrapper>
                  }
                />
              ))}
              {routes.authRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={<AuthWrapper>{route.element}</AuthWrapper>}
                />
              ))}
              {routes.PWARoute.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <GlobalWrapper
                      SidebarComponent={null}
                      sidebarTitle={null}
                      isPwa={isPwa}
                    >
                      {route.element}
                    </GlobalWrapper>
                  }
                />
              ))}
              {routes.PWAAddons.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <GlobalWrapper
                      SidebarComponent={PWASubMenu}
                      sidebarTitle={route?.title}
                      isPwa={isPwa}
                    >
                      {route.element}
                    </GlobalWrapper>
                  }
                />
              ))}
              
            </Routes>
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </div>
  );
}

export default App;

// //Messages
// const [show, setShow] = useState(false);
// const [notification, setNotification] = useState({title: '', body: ''});
// const [isTokenFound, setTokenFound] = useState(false);

// // const userToken = localStorage.getItem("message_token") && setTokenFound(true);
// const userToken = localStorage.getItem("message_token")
// // fetchToken(setTokenFound);

// useEffect(() => {
//   if (!userToken) {
//     fetchToken(setTokenFound);
//   } else {
//     console.log("userToken", userToken)
//   }
// }, []);

// // fetchToken(setTokenFound);

// onMessageListener().then(payload => {
//   setNotification({title: payload.notification.title, body: payload.notification.body})
//   setShow(true);
//   console.log("payload",payload);
// }).catch(err => console.log('failed: ', err));

// const onShowNotificationClicked = () => {
//   setNotification({title: "Notification", body: "This is a test notification"})
//   setShow(true);
// }

///////////////////////////////////////////////////////////////////////////////////
// //request notification permission
// useEffect(() => {
//   if (!tokenFound) {
//     notification.requestPermission().then(permission => {
//       if (permission === 'granted') {
//         fetchToken(setTokenFound);
//       }
//     });
//   }
// }
// , []);

// const { loginUser } = useSelector((state) => {
//   return {
//     loginUser: state.loginReducer.loginUser,
//   };
// });

// let userToken
// useEffect(() => {
//   // fetchToken(setTokenFound);
//   userToken = localStorage.getItem("message_token")
//   // console.log(userToken?.length)

// }, []);

// useEffect(() => {
//     if(userToken?.length < 10 || userToken === null) {
//       fetchToken(setTokenFound);
//     }
// }, []);

// const saveToken = async () => {
//   const usrtoken = JSON.parse(userToken);
//   const response = await registerNotificationToken(usrtoken, "userToken");
//   console.log('response: ', response);
// }

// useEffect(() => {
//   saveToken();
// }, [userToken]);
